import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DegradedModeService } from '../core/degraded-mode.service';

@Component({
  selector: 'app-degraded-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (unreachable$ | async) {
      <div class="degraded-banner" role="status" data-testid="degraded-banner"
           title="Support system is currently unreachable — try again shortly.">
        Support system is currently unreachable — try again shortly.
      </div>
    }
  `,
  styles: [`
    .degraded-banner {
      background: var(--bt-status-danger);
      color: #fff;
      padding: 0.5rem 1rem;
      text-align: center;
      font-weight: 600;
    }
  `],
})
export class DegradedBannerComponent {
  private degradedMode = inject(DegradedModeService);
  unreachable$ = this.degradedMode.apiUnreachable$;
}
